import { Monitor } from "@phosphor-icons/react";
import { Heading, Text } from "@radix-ui/themes";
import { useTranslation } from "react-i18next";

import LogotypeIcon from "../images/Logotype.svg";

export const MobileRedirectPage = () => {
  const { t } = useTranslation("components");
  return (
    <div
      className="bg-gray-100 fixed inset-0 flex h-screen flex-col overflow-hidden px-6"
      data-testid="mobile-redirect-page"
    >
      {/* PUNTT Logo at top */}
      <div className="flex justify-center pb-4 pt-8">
        <img
          src={LogotypeIcon}
          alt={t("mobileRedirectPage.puntt")}
          className="h-8"
          data-testid="mobile-redirect-logo"
        />
      </div>

      {/* Centered content block with computer icon, heading, and text */}
      <div className="flex min-h-0 flex-1 flex-col items-center justify-center">
        {/* Computer Monitor Icon */}
        <div
          className="bg-white mb-6 flex size-24 items-center justify-center rounded-2xl shadow-sm"
          data-testid="mobile-redirect-icon"
        >
          <Monitor size={48} className="text-gray-600" />
        </div>

        {/* Main Heading */}
        <Heading
          size="6"
          className="mb-4 text-center"
          data-testid="mobile-redirect-heading"
        >
          {t("mobileRedirectPage.mobileNotSupported")}
        </Heading>

        {/* Description Text */}
        <Text
          size="3"
          className="mb-1 max-w-xs text-center"
          data-testid="mobile-redirect-message-primary"
        >
          {t("mobileRedirectPage.weDonAposTSupport")}
        </Text>
        <Text
          size="3"
          className="max-w-xs text-center"
          data-testid="mobile-redirect-message-secondary"
        >
          {t("mobileRedirectPage.pleaseSwitchDesktopAccessPlatform")}
        </Text>
      </div>
    </div>
  );
};
